import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ModalProvider, useModal } from './contexts/ModalContext';
import { setModalController, setAuthController } from './services/api/client.api';
import MainLayout from './components/layout/MainLayout';
import Schedule from './pages/schedule/Schedule';
import ProgramsList from './pages/program-list/ProgramsList';
import Program from './pages/program/Program';
import CompleteProfile from './pages/complete-profile/CompleteProfile';
import Welcome from './pages/welcome/Welcome';
import Home from './pages/home/Home';
import Plan from './pages/plan/Plan';
import Requirement from './pages/requirement/Requirement';
import Pool from './pages/pool/Pool';
import Settings from './pages/settings/Settings';
import PrivacyPolicy from './pages/privacy/PrivacyPolicy';
import TermsOfService from './pages/terms/TermsOfService';

function AppContent() {
  const modal = useModal();
  const { logout } = useAuth();

  useEffect(() => {
    setModalController(modal);
    setAuthController({ clearAuth: logout });
  }, [modal, logout]);

  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        {/* Protected routes with layout */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/programs" element={<ProgramsList />} />
          <Route path="/programs/:programId" element={<Program />} />
          <Route path="/programs/:programId/requirements/:requirementId" element={<Requirement />} />
          <Route path="/programs/:programId/pools/:poolKey" element={<Pool />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''} locale="en">
      <Router>
        <AuthProvider>
          <ModalProvider>
            <AppContent />
          </ModalProvider>
        </AuthProvider>
      </Router>
    </GoogleOAuthProvider>
  );
}
